export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';
export const SELECT_BOOKING = 'SELECT_BOOKING';
export const SET_BOOKING_AUTH_REQUEST = 'SET_BOOKING_AUTH_REQUEST';
export const SET_CHECKIN_REQUEST = 'SET_CHECKIN_REQUEST';
export const SET_OPENABLE_MODAL_CONFIG = 'SET_OPENABLE_MODAL_CONFIG';
export const SET_SKIP_BOOKING_AUTH = 'SET_SKIP_BOOKING_AUTH';